/*
An input that displays in market product units, catalog units, or canonical units
but always returns canonical units
*/
import _ from 'lodash';
import catalogHelpers from 'goodeggs-purchase-orders-sdk/catalog/helpers';

export default __filename;
angular.module(__filename, []).directive(
  'inputQuantity',
  ngInject(() => ({
    restrict: 'E',
    scope: {
      modelValue: '=ngModel', // because we need to edit the model value directly
      catalogProduct: '=?',
      unitId: '=?',
      quantityMin: '=?',
      quantityMax: '=?',
      quantityDisabled: '=?',
      countUnitLabel: '=?',
      quantityChange: '&',
      hideError: '=?',
    },
    controllerAs: 'ctrl',
    bindToController: true,
    template: require('./template'),
    require: 'ngModel',
    controller: ngInject(function() {
      this.step = 1;
      return this; // http://stackoverflow.com/questions/28953289/using-controller-as-with-the-ui-router-isnt-working-as-expected
    }),

    link(scope, element, attr, ngModelCtrl) {
      let manuallyChanged = false;

      let catalogProduct = null;
      let converter = null;
      const updateConverter = function() {
        if (catalogProduct === scope.ctrl.catalogProduct) {
          return;
        } // no change
        ({catalogProduct} = scope.ctrl);
        if (!catalogProduct) {
          converter = null;
        } else {
          converter = catalogHelpers.unitConverter(catalogProduct);
        }
      };
      updateConverter();

      // default input to ng-model value passed in
      scope.ctrl.inputQuantity = ngModelCtrl.$viewValue;

      scope.ctrl.quantityMin = scope.ctrl.quantityMin ? Number(scope.ctrl.quantityMin) : 0;

      ngModelCtrl.$formatters.push(function(canonicalQuantity) {
        updateConverter();
        if (converter == null || canonicalQuantity == null || canonicalQuantity < 0) {
          return canonicalQuantity;
        }
        return converter.convertTo(canonicalQuantity, scope.ctrl.unitId);
      });

      ngModelCtrl.$parsers.push(function(unitQuantity) {
        updateConverter();
        if (converter == null || unitQuantity == null || unitQuantity < 0) {
          return unitQuantity;
        }
        return converter.convertFrom(unitQuantity, scope.ctrl.unitId);
      });

      ngModelCtrl.$render = () => (scope.ctrl.inputQuantity = ngModelCtrl.$viewValue);

      const whenUpdated = function() {
        if (!scope.ctrl.hideError) {
          switch (false) {
            case !(scope.ctrl.inputQuantity == null) || Boolean(manuallyChanged):
              scope.ctrl.error = null;
              return;
            case Boolean(_.isNumber(scope.ctrl.inputQuantity)):
              scope.ctrl.error = {message: 'Please enter a number'};
              return;
            case !(scope.ctrl.inputQuantity > scope.ctrl.quantityMax):
              scope.ctrl.error = {message: `Must be less than ${scope.ctrl.quantityMax}`};
              break;
            case !(scope.ctrl.inputQuantity < scope.ctrl.quantityMin):
              scope.ctrl.error = {message: `Must be greater than ${scope.ctrl.quantityMin}`};
              break;
            default:
              scope.ctrl.error = null;
          }
        }

        ngModelCtrl.$setViewValue(scope.ctrl.inputQuantity);
        return typeof scope.ctrl.quantityChange === 'function'
          ? scope.ctrl.quantityChange()
          : undefined;
      };

      scope.$watch('ctrl.inputQuantity', whenUpdated);
      scope.$watch('ctrl.quantityMin', whenUpdated);
      scope.$watch('ctrl.quantityMax', whenUpdated);

      scope.$watch('ctrl.catalogProduct._id', function() {
        updateConverter();
        if (converter != null && ngModelCtrl.$viewValue != null) {
          scope.ctrl.modelValue = converter.convertFrom(ngModelCtrl.$viewValue, scope.ctrl.unitId);
        } else {
          scope.ctrl.modelValue = ngModelCtrl.$viewValue;
        }
      });

      scope.ctrl.onChange = () => (manuallyChanged = true);
    },
  })),
);
